import { render, staticRenderFns } from "./modelDeatail.vue?vue&type=template&id=b2d6a324&scoped=true"
import script from "./modelDeatail.vue?vue&type=script&lang=js"
export * from "./modelDeatail.vue?vue&type=script&lang=js"
import style0 from "./modelDeatail.vue?vue&type=style&index=0&id=b2d6a324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d6a324",
  null
  
)

export default component.exports